<template>
  <v-dialog v-model="$loja_consumidor.dialogExport" max-width="1200">
    <v-card class="modal-body-consumidor-exportar">
      <div
        class="consumidor-modal-exportacao-container animate__animated animate__bounceInDown animate__delay-0.5s"
      >
        <div class="consumidor-modal-exportacao-container01">
          <h1 class="consumidor-modal-exportacao-text">
            {{ $t("customers.export") }} {{ $t("customers.title") }}
          </h1>
          <v-btn icon @click="closeModal">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </div>
        <div class="consumidor-modal-exportacao-container02">
          <div class="consumidor-modal-exportacao-container03">
            <div class="consumidor-modal-exportacao-container04">
              <span>{{ $t("customers.export") }}:</span>
            </div>
            <v-radio-group v-model="exportar" mandatory>
              <v-radio
                :label="$t('customers.all-customers')"
                value="todos_consumidores"
              ></v-radio>
              <v-radio
                :label="
                  $loja_consumidor.select_consumidores.length > 1
                    ? $t('customers.selected-plural') +
                      $loja_consumidor.select_consumidores.length +
                      ` ${$t('customers.title')}`
                    : $t('customers.selected') +
                      $loja_consumidor.select_consumidores.length +
                      ` ${$t('customers.customer')}`
                "
                value="selecionados"
              ></v-radio>
            </v-radio-group>
          </div>
          <div class="consumidor-modal-exportacao-container03">
            <div class="consumidor-modal-exportacao-container04">
              <span>{{ $t("customers.export-as") }}</span>
            </div>
            <v-radio-group v-model="exportat_como" mandatory>
              <v-radio label="CSV" value="csv"></v-radio>
            </v-radio-group>
          </div>
        </div>
        <div class="consumidor-modal-exportacao-container05">
          <v-btn
            height="45"
            class="consumidor-modal-exportacao-button button button-bg"
            @click="exportarConsumidores"
          >
            {{ $t("customers.export") }}
          </v-btn>
          <v-btn
            height="45"
            class="consumidor-modal-exportacao-button button button-bg"
            @click="closeModal"
          >
            {{ $t("customers.cancel") }}
          </v-btn>
        </div>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
import LojaConsumidorMixins from "@/mixins/Loja-Consumidor.mixins.js";
export default {
  name: "ModalExportarConsumidor",
  mixins: [LojaConsumidorMixins],
  data() {
    return {
      exportar: "",
      exportat_como: "csv",
    };
  },
  methods: {
    closeModal() {
      this.$loja_consumidor.dialogExport = false;
    },
  },
};
</script>

<style scoped>
.modal-body-consumidor-exportar {
  /* Hidden by default */
  position: fixed;
  /* Stay in place */
  z-index: 999;
  /* Sit on top */
  left: 0;
  top: 0;
  width: 100%;
  /* Full width */
  height: 100%;
  /* Full height */
  overflow: auto;
  /* Enable scroll if needed */
  background-color: rgb(0, 0, 0);
  /* Fallback color */
  background-color: rgba(0, 0, 0, 0.4);
  /* Black w/ opacity */
  justify-content: center;
  align-items: center;
  overflow-y: auto;
  display: flex;
  border-radius: 1.25rem;
  flex-direction: column;
}

.consumidor-modal-exportacao-container {
  width: 600px;
  height: auto;
  display: flex;
  z-index: 100;
  position: relative;
  box-shadow: 1px 1px 30px 3px #000000;
  align-items: center;
  border-radius: 1.25rem;
  flex-direction: column;
  justify-content: flex-start;
  background-color: #eaeaea;
  padding: 1.25rem;
}

.consumidor-modal-exportacao-container01 {
  flex: 0 0 auto;
  width: 100%;
  height: auto;
  padding-bottom: 1rem;
  display: flex;
  align-items: center;
  flex-direction: row;
  justify-content: center;
}

.consumidor-modal-exportacao-text {
  font-size: 1.5em;
  margin-left: auto;
  margin-right: auto;
}

.consumidor-modal-exportacao-icon {
  width: 24px;
  height: 24px;
  right: 8px;
  transition: all 0.3s ease;
}

.consumidor-modal-exportacao-icon:hover {
  fill: #fff;
  cursor: pointer;
}

.consumidor-modal-exportacao-container02 {
  flex: 0 0 auto;
  width: 100%;
  height: auto;
  display: flex;
  align-items: center;
  padding-left: 1.25rem;
  padding-right: 1.25rem;
  flex-direction: column;
  justify-content: center;
}

.consumidor-modal-exportacao-container03 {
  width: 100%;
  display: flex;
  align-items: flex-start;
  padding-top: 1.25rem;
  padding-right: 1.25rem;
  padding-bottom: 1.25rem;
  padding-left: 1.25rem;
  border-radius: 0.9rem;
  margin-bottom: 20px;
  flex-direction: column;
  justify-content: center;
  background-color: #c9c9c9;
}

.consumidor-modal-exportacao-container04 {
  width: 100%;
  display: flex;
  align-items: center;
  flex-direction: row;
  justify-content: flex-start;
}

.consumidor-modal-exportacao-container05 {
  flex: 0 0 auto;
  width: 100%;
  height: auto;
  display: flex;
  align-items: center;
  padding-left: 1.25rem;
  padding-right: 1.25rem;
  flex-direction: column;
  justify-content: center;
  margin-bottom: 1.25rem;
}

.consumidor-modal-exportacao-button {
  width: 100%;
  border-radius: 0.9rem;
}

.consumidor-modal-exportacao-button:first-child {
  margin-bottom: 0.6rem;
}
</style>
